/**
 * Auth route
 */

// React
import React from 'react';

// Libraries
import { Navigate, useLocation } from 'react-router-dom';

// Components
import AuthLayout from './AuthLayout';

// Hooks
import useLocalStorage from 'hooks/useLocalStorage';

// Utils
import { STORAGE_KEYS } from 'utils/constants';

// Utils
import { CombinedRouteProps } from 'utils/types';

// Router
import ROUTES from 'configs/route';

// Define the AuthRoute component
const AuthRoute: React.FC<CombinedRouteProps> = ({
  children,
  showHeader = true,
  showFooter = true,
  maxWidth,
  alignItems = 'start',
}) => {
  const location = useLocation();
  const [accessToken] = useLocalStorage(STORAGE_KEYS.ACCESS_TOKEN);

  if (accessToken) {
    return <Navigate to={ROUTES.USER_INFO} state={{ from: location }} />;
  }

  // Authorized, so return the children wrapped with AppLayout
  return (
    <AuthLayout
      showHeader={showHeader}
      alignItems={alignItems}
      showFooter={showFooter}
      maxWidth={maxWidth}
    >
      {children}
    </AuthLayout>
  );
};

export default AuthRoute;
